import { AxiosRequestConfig } from 'axios';

import { MOKA_SERVICE_HOST, MOKA_GOAUTH_SERVICE } from '../../api/constants';

/**
 * Rewrite certain paths to the corresponding host, acting like a proxy
 *
 * TODO This rewrite is preferably to be server side
 */
function rewriteUrls(config: AxiosRequestConfig) {
  if ((config.url as string).startsWith('/mkService/')) {
    config.url = (config.url as string).replace('/mkService/', '/mkGoAuth/');
  }

  // Do not rewrite in test
  // Also do not rewrite for local since we are already proxying
  if (
    process.env.NODE_ENV === 'test' ||
    window.location.host === 'local.mokapos.com:3002'
  ) {
    return config;
  }

  // Define a list of mapping. Keys of this mapping will be replaced by values.
  const urlMap = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '/mkService/': MOKA_SERVICE_HOST,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '/mkGoAuth/': MOKA_GOAUTH_SERVICE,
  };

  // Find if there is any matching key. If there is, replace it with its value.
  // It should have at most one match at any time.
  for (const [src, dest] of Object.entries(urlMap)) {
    if ((config.url as string).startsWith(src)) {
      config.url = (config.url as string).replace(src, `${dest}/`);
      break;
    }
  }

  return config;
}

export default rewriteUrls;
